// React
import React from 'react';
import { Controller } from 'react-hook-form';
// material-ui components
import Divider from '@mui/material/Divider';
import TextField from '@mui/material/TextField';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
// custom components
import NumberedHeading from '../../../../../shared-components/forms/NumberedHeading';
import IntroImageAndTextSlideArray from './components/IntroImageAndTextSlideArray';

const IntroCarousel = (props) => {
  const { control, formState } = props.methods;
  const { errors } = formState;
  const { inputDir } = props;

  return (
    <div>
      <NumberedHeading number="1" title="Slides" instructions="Using the controls below, please add slides for this page." />
      <Controller
        control={control}
        name="content.core"
        render={({field}) => <IntroImageAndTextSlideArray inputDir={inputDir} {...{control, errors}} />}
      />
    </div>
  );
};

export default IntroCarousel;